import React from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

const PaymentCancel = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <div className="p-6"><Logo /></div>
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-md w-full rounded-2xl border border-border/50 bg-card p-10 text-center" data-testid="payment-cancel-card">
          <div className="w-16 h-16 rounded-2xl bg-white/5 flex items-center justify-center mx-auto"><XCircle className="w-9 h-9 text-muted-foreground" /></div>
          <h1 className="font-heading text-2xl font-bold mt-6">Checkout cancelled</h1>
          <p className="text-muted-foreground mt-2">No charge was made. You can pick a plan whenever you're ready to grow.</p>
          <Button onClick={() => navigate("/plans")} className="mt-7 rounded-full h-11 px-8 bg-primary text-background font-bold hover:bg-primary/90 transition-colors" data-testid="back-to-plans-btn">
            Back to plans
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
